export class TherapistDashboardModel {

  public queueLength?: number;
  public queueLengthMinutes?: number;
  public numberOfBookingsCompleted?: number;
  public totalWaitingForAnyone?: number;
  public totalWaitingForMe?: number;
  public currentStatusID?: number;
  public isClockedIn?: boolean;
}
